// 紙吹雪
import isMotionReduced from './motion_reduce';

let options = {
  rootMargin: '-300px',
};

const BREAK_POINT = 768
const messageArea = document.querySelector('.js-message');
const confettiArea = document.querySelector('.js-confetti');

// Blogger's Messageエリアが300px以上(SP時は160px)見えたら5s間だけ紙吹雪を降らせる
export default function confetti() {
  document.addEventListener('DOMContentLoaded', () => {
    if (isMotionReduced()) {
      return
    }

    if (window.innerWidth < BREAK_POINT) {
      options = {
        rootMargin: '-160px',
      };
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return
        }

        show();
        setTimeout(fadeout, 4500);
        observer.unobserve(entry.target);
      });
    }, options);

    observer.observe(messageArea);
  });
}

const fadeout = () => {
  confettiArea.classList.add('is-fadeout');
  setTimeout(remove, 500);
}

const show = () => {
  confettiArea.classList.add('is-visible');
}

const remove = () => {
  confettiArea.parentNode.removeChild(confettiArea);
}

confetti();
